// Imports Dependencies
import Vue from "vue";

// Determines the month string
const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];

Vue.filter("fileDate", (date: any) => {
    if (!date) {
        return '';
    }

    let month_val = date.getMonth() + 1;
    month_val = month_val < 10 ? `0${month_val}` : month_val;
    return `${date.getDate()}-${month_val}-${date.getFullYear()}`;
});

Vue.filter("shortDate", (date: any) => {
    if (!date) {
        return '';
    }

    let month_val = date.getMonth() + 1;
    month_val = month_val < 10 ? `0${month_val}` : month_val;
    return `${date.getDate()}/${month_val}/${date.getFullYear()}`;
});

Vue.filter("shortDateTime", (date: any) => {
    if (!date) {
        return '';
    }

    let month_val = date.getMonth();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    return `${months[month_val > 11 ? 0 : month_val]} ${date.getDate()}, ${hours}:${minutes == 0 ? '00' : minutes}`;
});

Vue.filter("longDate", (date: Date) => {
    if (!date) {
        return '';
    }

    // Determines the month string
    let month_val: number = date.getMonth();

    // Determines the extension for the date
    let date_ext: string = "th"
    let date_num: number = date.getDate();
    if (date_num.toString().slice(-1) === '1') {
        date_ext = date_num.toString().slice(-2) === '11' ? "th" : "st";
    } else if (date_num.toString().slice(-1) === '2') {
        date_ext = date_num.toString().slice(-2) === '12' ? "th" : "nd";
    } else if (date_num.toString().slice(-1) === '3') {
        date_ext = date_num.toString().slice(-2) === '13' ? "th" : "rd";
    }

    return `${date.getDate()}${date_ext} ${months[month_val]} ${date.getFullYear()}`;
});

Vue.filter("longDateTime", (date: any) => {
    if (!date) {
        return '';
    }

    // Determines the month string
    let month_val = date.getMonth() + 1;

    // Determines the extension for the date
    let date_ext = "th"
    let date_num = date.getdate();
    if (date.slice(-1) === '1') {
        date_ext = date.slice(-2) === '11' ? "th" : "st";
    } else if (date.slice(-1) === '2') {
        date_ext = date.slice(-2) === '12' ? "th" : "nd";
    } else if (date.slice(-1) === '3') {
        date_ext = date.slice(-2) === '13' ? "th" : "rd";
    }

    let hours = date.getHours();
    let minutes = date.getMinutes();

    return `${hours}:${minutes == 0 ? '00' : minutes}, ${date.getDate()}${date_ext} ${months[month_val]} ${date.getFullYear()}`;
});

Vue.filter("extendedLongDate", (date: any) => {
    if (!date) {
        return '';
    }
    
    let month_val = date.getMonth();
    let day = date.getDate().toString();

    // Determines the extension for the date
    let date_ext = "th";
    if (day.slice(-1) === '1') {
        date_ext = day.slice(-2) === '11' ? "th" : "st";
    } else if (day.slice(-1) === '2') {
        date_ext = day.slice(-2) === '12' ? "th" : "nd";
    } else if (day.slice(-1) === '3') {
        date_ext = day.slice(-2) === '13' ? "th" : "rd";
    }

    return `${date.getDate()}${date_ext} ${months[month_val]} ${date.getFullYear()}`;
});

Vue.filter("isoDate", (date: any) => {
    if (!date) {
        return '';
    }
    
    let month_val = date.getMonth() + 1;
    month_val = month_val < 10 ? `0${month_val}` : month_val;
    return `${date.getFullYear()}-${month_val}-${date.getDate()}`;
});